import React from 'react';
import Modal from 'react-bootstrap/Modal';
export const ModalView = ({ close, data, }) => (React.createElement(React.Fragment, null,
    React.createElement(Modal.Header, { closeButton: true },
        React.createElement(Modal.Title, { as: "h3" }, data.notification.title || data.notification.data.title)),
    React.createElement(Modal.Body, { className: "pt-1" },
        React.createElement("p", { className: "pb-3" }, data.notification.body || data.notification.data.body || data.notification.title || data.notification.data.title),
        React.createElement("div", { className: "pb-3" },
            React.createElement("button", { type: "button", className: "can-btn", onClick: close }, "OK")))));
